import clsx from 'clsx';
import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';

import checkMarkSrc from '../../../../assets/images/check_mark.svg';

import { forum_path, forum_post_path } from '../../../routes';
import { ForumPost } from '../../../utils/backend-api/forumPosts';
import ForumPostScreenshot, { useForumPostScreenshot } from '../ForumPostPage/ForumPostScreenshot';
import ShareModalContent from '../ShareModal/ShareModalContent';
import styles from './styles.module.scss';

export default function CreatedCommentSuccess({ forumPost }: { forumPost: ForumPost }) {
  const body = ReactHtmlParser(forumPost.comment.body);
  const { onDownloadScreenshot, renderScreenshotContent } = useForumPostScreenshot(
    forumPost?.title
  );

  return (
    <>
      {!!renderScreenshotContent && (
        <ForumPostScreenshot
          title={forumPost.title}
          body={body}
          renderScreenshotContent={renderScreenshotContent}
          length={forumPost.comment.body.length}
        />
      )}
      <div className="forum-post-form">
        <ShareModalContent
          title="Success! Your post is published"
          subtitle="Share your post with others"
          forumPost={forumPost}
          iconSrc={checkMarkSrc}
          onDownloadScreenshot={onDownloadScreenshot}
        />
        <div className={styles.viewPostButtonContainer}>
          <Link
            to={forum_post_path(forumPost.id)}
            className={clsx(styles.submitButton, 'button button-red button-small')}
          >
            View My Post
          </Link>
          <Link
            to={forum_path()}
            className={clsx(styles.submitButton, 'button button-secondary button-small')}
          >
            Back to Forum
          </Link>
        </div>
      </div>
    </>
  );
}
